<template>
  <div class="header bg-white flex-lr" :class="hasTest()?'test-style':''">
    <div class="flex-lm">
      <el-menu default-active="" class="el-menu-vertical-demo" v-if="isManager"
               background-color="#ffffff"
               text-color="#2c3e50" router collapse
               active-text-color="#ffd04b">
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-cpu" style="font-size: 40px; color: #2c3e50;"></i>
            <span slot="title">运营管理</span>
          </template>
          <el-menu-item-group>
            <span slot="title" style="color: #666666;">Ver 1.0 bate</span>
            <el-menu-item index="/operate/notice">发布公告</el-menu-item>
            <el-menu-item index="/operate/activitys">活动管理</el-menu-item>
            <el-menu-item index="/operate/members">用户管理</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
      <div class="header-left">
        <slot name="act"></slot>
      </div>
    </div>
    <div class="header-right flex-rr">
      <slot name="search"></slot>
      <!--
      <a href="https://support.qq.com/product/57964" target="_blank" class="black-font font-size14" style="margin-right: 20px;">帮助与反馈</a>
      <a href="https://openai.weixin.qq.com/webapp/jDgwDGsnHz8LXBmMwbNBffXZuPqmsS?robotName=Fotoo%E5%BE%81%E9%9B%86%E4%B8%80%E4%B8%8B" target="_blank" style="padding-top: 2px;" class="flex-lm">
        <img src="https://assets.pfotoo.com/pc/img/service.svg" style="width: 20px;height: 20px;margin-right: 5px;"/>
        <div class="black-font font-size14">客服</div>
      </a>
      -->
      <div class="flex align-center justify-end tap margin-right" @click="messageNoticeShow">
        <div class="message-icon"></div>
        <div>消息提醒</div>
      </div>
      <div class="user flex-vc">
        <memberAvatar :userinfo="userinfo"></memberAvatar>
        <!--
        <img :src="userinfo.avatar" class="header-img"/>
        <div class="login-out" @click="logout">
          <div class="login-out-angle bg-white"></div>
          <div style="height: 10px;"></div>
          <div class="login-out-font black-font font-size14 flex-cm bg-white">退出</div>
        </div>
        -->
      </div>
    </div>
    <div style="position: absolute;">
      <el-popover popper-class="el-popover-help"
                  placement="right"
                  width="400"
                  trigger="hover">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="text-500 text-lg">帮助中心</span>
          </div>
          <div class="flex align-center justify-start">
            <div class="gzh-258"></div>
            <div>
              <div class="text-df text-500">
                扫码关注“Fotoo征集一下”公众号
              </div>
              <div class="text-left-iconright">
                接收活动消息
              </div>
              <div class="text-left-iconright">
                获取免费攻略
              </div>
            </div>

          </div>
          <div class="flex align-center justify-between padding-lr margin-top">
            <div class="text-left-iconright iconservice" @click="serviceDialogShow">客服中心</div>
            <a href="https://support.qq.com/product/57964" target="_blank">
              <div class="text-left-iconright iconfankui">反馈建议</div>
            </a>
          </div>
        </el-card>
        <div slot="reference" class="fixed-right-help flex align-center justify-center">
          <div class="fixed-right-help-text">帮助中心</div>
        </div>
      </el-popover>
      <messageNotice ref="messageNotice"></messageNotice>
      <serviceDialog ref="serviceDialog" src="https://assets.pfotoo.com/qrcode/qy-pc.png"></serviceDialog>
    </div>
  </div>

</template>

<script>
  import App from '../util/comfun'
  import memberAvatar from './dialog/memberAvatar.vue'
  import messageNotice from './dialog/messageNotice.vue'
  import serviceDialog from './dialog/service-dialog.vue'
  export default {
    name: 'header',
    data () {
      return {
        userinfo:{

        },
        isManager:false,
      }
    },
    components:{
      memberAvatar,
      messageNotice,
      serviceDialog,
    },
    methods:{
      getuserinfo(){
        App.User.GetUserById().then(res=>{
          if(res.code==200){
            this.userinfo=res.data
            //wxlite.setStorageSync('userinfo',JSON.stringify(this.userinfo))
          }
        })
        //this.userinfo=JSON.parse(sessionStorage.getItem('userinfo'))
        return;
       this.$http({
         url:'https://pfotoo.com?s=App.User.GetUserById'+this.$getsign(),
         params:{
           openid:JSON.parse(localStorage.getItem('userinfo')).openid
         },
         dataType:'json',
         method:'POST',
         headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
         },
       }).then((res)=>{
         console.log(res.body)
         let json=res.body;
         if(res.body.ret==200){
            this.userinfo=json.data;
           localStorage.setItem('userinfo',JSON.stringify(json.data))
         }
       })
     },
     logout(){
       console.log('ttttt')
       localStorage.removeItem('userinfo');
       localStorage.removeItem('token');
       this.$router.replace({
         path:'/'
       })
     },
      hasTest:App.hasTestStyle,
      messageNoticeShow(){
       this.$refs.messageNotice.show()
      },
      serviceDialogShow(){
        this.$refs.serviceDialog.show()
      },
    },
    mounted(){
      this.getuserinfo();
      App.User.GetOperate().then(res=>{
        if(res.code==200 && res.data){
          this.isManager=res.data.isManager
        }
      })
    },

  }
</script>

<style>
  .header {
      height: 67px;
      left: 200px;
      padding: 0 40px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      z-index: 99;
      -webkit-box-shadow: 0 0 4px 1px rgba(0,0,0,.05);
      box-shadow: 0 0 4px 1px rgba(0,0,0,.05);
      position: fixed;
      right:0;
      top:0;
  }
  .user {
      position: relative;
      cursor: pointer;
      margin-left: 20px;
  }
  .login-out {
      width: 90px;
      height: 50px;
      position: absolute;
      right: -30px;
      top: 67px;
      border-radius: 2px;
      display: none;
  }
  .login-out-angle{
      width: 10px;
      height: 10px;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      position: absolute;
      top: 5px;
      left: 0;
      right: 0;
      margin: 0 auto;
  }
  .login-out-font {
      width: 100%;
      height: 40px;
      position: relative;
      z-index: 2;
  }
  .login-out-angel,.login-out-font{
      border-radius: 2px;
      -webkit-box-shadow: 0 0 4px rgba(0,0,0,.1);
      box-shadow: 0 0 4px rgba(0,0,0,.1);
  }
  a, a:hover {
      text-decoration: none;
  }
  .user:hover .login-out{
    display: block;
  }
  .el-menu-vertical-demo.el-menu{
    margin-left: -40px;
    border-right-width:0;

  }
  .fixed-right-help{
    width: 40px;
    height: 120px;
    background: #FFFFFF;
    box-shadow: 0 0 4px 0 #76747480;
    border-radius: 15px 1px 1px 15px;

    position: fixed;
    right: 0;
    top:45%;


    white-space: normal; /* 保留空白符序列，但是正常换行 */
    word-break: break-all; /* 允许在单词内换行 */
  }
  .fixed-right-help-text{
    width: 21px;
    height: 92px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #353535;
    line-height: 23px;
  }
  .el-popover-help.el-popover {
    padding: 0;
    border-width:0px;
  }
  .gzh-258{
    background-image: url("https://assets.pfotoo.com/qrcode/gzh-258.jpg");
    width: 97px;
    height: 95px;
    background-size: 100% 100%;
  }
  .message-icon{
    background-image: url("https://assets.pfotoo.com/images/pc-help/%E6%B6%88%E6%81%AF%E6%8F%90%E9%86%92@3x.png");
    width: 18px;
    height: 17px;
    background-size: 100% 100%;
    margin-right: 5px;

    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #353535;
    text-align: right;
  }
  .text-left-iconright{
    background-image: url("https://assets.pfotoo.com/images/pc-help/%E5%AF%B9%E5%8F%B7%E5%A4%87%E4%BB%BD@3x.png");
    background-size: 15px 12px;
    background-repeat: no-repeat;
    text-indent: 20px;
    height: 20px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    margin-top: 10px;
    background-position: left center;
  }
  .iconservice{
    background-image: url("https://assets.pfotoo.com/images/pc-help/%E5%AE%A2%E6%9C%8D@3x.png");
    background-size: 20px 20px;
    text-indent: 30px;
  }
  .iconfankui{
    background-image: url("https://assets.pfotoo.com/images/pc-help/%E5%8F%8D%E9%A6%88%20@3x.png");
    background-size: 20px 20px;
    text-indent: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue